import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface Step5SolutionProps {
  onNext: () => void;
}

const Step5Solution: React.FC<Step5SolutionProps> = ({ onNext }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      className="p-6 max-w-lg mx-auto text-center"
    >
      {/* Icon */}
      <div className="mb-6">
        <div className="w-20 h-20 mx-auto bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full flex items-center justify-center">
          <Lightbulb className="h-10 w-10 text-white" />
        </div>
      </div>

      {/* Headline */}
      <h2 className="text-3xl font-bold text-gray-900 mb-4">
        Your Ideas, <span className="text-nocode-blue">Unleashed</span>:{' '}
        <span className="text-nocode-purple">Build & Own</span> with AI.
      </h2>

      {/* Body Text */}
      <p className="text-gray-600 text-lg leading-relaxed mb-8">
        This course is your blueprint to bypass traditional development barriers. AI becomes your intelligent co-pilot, simplifying complex tasks, accelerating creation, and empowering you to launch and truly own your web apps, tools, and websites, even without extensive coding.
      </p>

      {/* Decorative Elements */}
      <div className="mb-8 flex justify-center space-x-4">
        <div className="w-3 h-3 bg-nocode-blue rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
        <div className="w-3 h-3 bg-nocode-purple rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
        <div className="w-3 h-3 bg-yellow-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
      </div>

      {/* CTA Button */}
      <Button
        onClick={onNext}
        size="lg"
        className="bg-gradient-to-r from-nocode-blue to-nocode-purple text-white hover:opacity-90 font-semibold px-8 py-3 text-lg rounded-full transition-all duration-300"
      >
        Continue
      </Button>
    </motion.div>
  );
};

export default Step5Solution;